import React from "react";

const Loader = () => {
  return (
    <>
      <style>
        {`
          .loader-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 999999;
          }

          .loader-container {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .loader-spinner {
            width: 55px;
            height: 55px;
            border: 5px solid #e5e5e5;
            border-top: 5px solid #0d6efd;
            border-radius: 50%;
            animation: loaderSpin 0.8s linear infinite;
          }

          .loader-text {
            margin-top: 12px;
            font-size: 14px;
            font-weight: 600;
            color: #444;
          }

          @keyframes loaderSpin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <div className="loader-overlay">
        <div className="loader-container">
          <div className="loader-spinner"></div>
          <div className="loader-text">Loading...</div>
        </div>
      </div>
    </>
  );
};

export default Loader;